export const en = {
    'ad-group-bad-geo-for-belarusian':
        'Display region may not be changed since the {bannerId} ad text is in Belarusian. Ad may only be served in Belarus.',
    'ad-group-bad-geo-for-default': '{bannerId} ad language does not match the selected display region.',
    'ad-group-bad-geo-for-kazakh':
        'Display region may not be changed since the {bannerId} ad text is in Kazakh. Ad may only be served in Kazakhstan.',
    'ad-group-bad-geo-for-turkish':
        'Display region may not be changed since the {bannerId} ad text is in Turkish. Ad may only be served in Turkey.',
    'ad-group-bad-geo-for-ukraine':
        'Display region may not be changed since the {bannerId} ad text is in Ukrainian. Ad may only be served in Ukraine.',
    'default-error': 'Unknown error: {codeError}',
    'general-rate-required': 'Set a bid for the new criteria',
    'geo-empty-regions': 'Select display regions',
    'geo-ids-incorrect-regions': 'Nonexistent region: {regionIds}',
    'geo-minus-region-matches-plus-region':
        'Invalid format, excluded region {minusRegionIds} may not be removed from display region {regionIds}',
    'geo-minus-regions-without-plus-regions':
        'Exception contains regions that are not found in any display region: {regionIds}',
    'geo-no-plus-regions': 'No display region',
    'incorrect-goal-id': 'Incorrect goal specified',
    'invalid-max-value-level': 'Value may not exceed {max}',
    'key-words-limit': 'Exceeded limit of {count} keywords',
    'library-list-minus-keywords-max': 'Maximum number of linked sets: {maxSize}',
    'library-list-minus-keywords-object-not-found': 'The set you selected has been deleted',
    'max-groups-in-campaign': 'Maximum number of ad groups per campaign reached',
    'max-retargetings-size': {
        one: "You can't select more than {count} retargeting list",
        some: "You can't select more than {count} retargeting lists",
        many: "You can't select more than {count} retargeting lists",
        none: "You can't select more than {count} retargeting lists"
    },
    'minus-keywords-max-length':
        'Negative keyword exceeds the allowed {maxLength} character length. Error in keyword: {minusWords}',
    'name-empty': 'Group name not entered',
    'name-max-length': 'Group name cannot be longer than {maxLength} characters',
    'name-prohibited-symbols': 'Group name contains invalid characters',
    'page-blocks-are-required': 'Please specify the advertising surfaces',
    'phrase-cannot-be-empty': 'Keyword cannot be empty',
    'phrase-illegal-characters':
        'Keyword text may only contain English, Turkish, Kazakh, Russian, Ukrainian, and Belarusian letters as well as quotation marks, "-", "+", "!", and spaces. Error in keyword: {phrase}',
    'phrase-incorrect-use-of-parenthesis':
        'Error using the operator may have used unpaired brackets in the keyword: {phrase}',
    'phrase-invalid-apostrophe': 'Invalid use of " \' " in keyword: {phrase}',
    'phrase-invalid-brackets': 'Invalid use of brackets [] in keyword: {phrase}',
    'phrase-invalid-exclamation-mark': 'Invalid use of "!" in keyword: {phrase}',
    'phrase-invalid-minus-mark': 'Invalid use of "-" in keyword: {phrase}',
    'phrase-invalid-plus-mark': 'Invalid use of "+" in keyword: {phrase}',
    'phrase-invalid-point': 'Invalid combination of special characters in keyword: {phrase}',
    'phrase-invalid-quotes': 'Invalid use of quotation marks in keyword: {phrase}',
    'phrase-minus-keywords-max-length': 'Negative keyword "{minusWord}" exceeds the allowed character length.',
    'phrase-minus-word-delete-plus-word':
        'You cannot edit a word ({word}) that is contained in the original keyword: {phrase}',
    'phrase-minus-word-inside-brackets-or-quotes':
        'Negative keywords may not be in quotation marks or square brackets. Error in keyword: {phrase}',
    'phrase-no-plus-words': 'Keywords may not contain only negative keywords',
    'phrase-not-single-minus-word': 'Only individual words may be removed from keywords, not phrases: {phrase}',
    'phrase-only-stop-words':
        'Keywords may not contain only stop words (conjunctions, prepositions, articles): {phrase}',
    'phrase-plus-mark-in-brackets':
        '"+" may not be used in quotation marks or square brackets. Error in keyword: {phrase}',
    'phrase-too-long-keyword': 'Keyword exceeds the allowed {maxLength} character length: {phrase}',
    'phrase-too-long-word':
        'Individual keyword exceeds the allowed {maxLength} character length. Error in keyword: {word}',
    'phrase-too-many-words': 'Keywords may not contain more than {maxWords} words. Error in keyword: {phrase}',
    'phrases-cannot-be-empty': 'Specify keywords',
    'retargeting-condition-cannot-be-empty': 'Specify impression criteria',
    'retargeting-condition-name-cannot-be-empty': 'Enter a name for the audience',
    'retargeting-condition-not-found': 'One of the retargeting conditions selected was deleted',
    'retargeting-condition-only-symbols':
        'In the retargeting list name, you can use only Latin, Turkish, Russian, Ukrainian, and Kazakh letters, numbers, and punctuation marks.',
    'retargeting-conditions-name-max-length': 'The maximum length of the name is {maxLength} characters',
    'tags-duplicated-error': 'Tags must be unique',
    'tags-invalid-value': 'The tag must contain only Latin characters, numbers, underscores and dashes',
    'tags-keyword-length-max': {
        one: 'Maximum tag length: {maxLength} character',
        some: 'Maximum tag length: {maxLength} characters',
        many: 'Maximum tag length: {maxLength} characters',
        none: 'Maximum tag length: {maxLength} characters'
    },
    'tags-keywords-max': 'Maximum number of assigned tags: {maxSize}',
    'test-page-error': 'An error occurred. Open the map with the advertising surfaces and click Save.',
    'too-wide-geotargeting-smart': 'Geotargeting group is bigger than smart banner country list',
    'yandexuids-cannot-be-empty': 'Field cannot be empty',
    'yandexuids-invalid-value': 'Invalid value (enter a value between 17-19 numbers)'
};
